import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import queryString from 'query-string';
import { Button, Row, Col } from 'antd';
import SignUpStyleWrapper from '../SignUp/SignUp.styles';
import authAction from '@iso/redux/auth/actions';
import logo from '@iso/assets/images/logo.png';
import { handleShowRandomImage } from '@iso/constants/randomBackgrounds';
import AgencyStyleWrapper from '../Agency/Agency.styles';

let images = handleShowRandomImage();
const { logout } = authAction;

const InvitationConflict = () => {
  const [invitedEmail, setInvitedEmail] = useState('');
  const [token, setToken] = useState('');
  const currentUser = useSelector((state) => state.user.user);
  const activeAgent = useSelector((state) => state.property.agent);
  const dispatch = useDispatch();
  const history = useHistory();

  let appLogo = activeAgent && activeAgent.logos
    ? activeAgent.logos[activeAgent.logos.length - 1]
    : null;
  appLogo = appLogo ? appLogo.full_path : logo;

  useEffect(() => {
    // Parse URL parameters
    const params = queryString.parse(window.location.search);
    const inviteToken = params.token || '';
    const email = params.email || '';
    
    setToken(inviteToken);
    setInvitedEmail(decodeURIComponent(email));
  }, []);

  const handleLogoutAndContinue = () => {
    // Clear current session and redirect to signup with invite token
    dispatch(logout());
    
    // Build signup URL with invitation parameters
    const signupParams = queryString.stringify({
      token,
      email: invitedEmail
    });
    
    // Redirect to signup page with invitation token
    history.push(`/signup?${signupParams}`);
  };

  const handleSkipInvite = () => {
    // Redirect to dashboard, keeping current user logged in
    history.push('/dashboard');
  };

  return (
    <>
      <style>
        {`
          .skip-invite-btn:hover {
            border-color: #40a9ff !important;
            color: #40a9ff !important;
            background-color: rgba(64, 169, 255, 0.1) !important;
          }
        `}
      </style>
      <Row
        className="signInmain"
        style={{ padding: "12px", height: "100vh", Width: "100%" }}
      >
      <Col xl={16} className="signIncol">
        <img
          src={`${images}`}
          height="98%"
          width="100%"
          style={{ borderRadius: "12px" }}
          alt="Background"
        />
      </Col>
      <Col xl={8}>
        <AgencyStyleWrapper agent={activeAgent}>
          <SignUpStyleWrapper className={`isoSignUpPage`}>
            <div className={`isoSignUpContentWrapper`}>
              <div className={`isoSignUpContent`}>
                <div className="isoLogoWrapper">
                  <img src={appLogo} height="50" alt="Logo" />
                </div>
                
                <div className="isoSignUpForm">
                  <Row className="mainFromDiv">
                    <Col xl={24} className="fromCol">
                      <div style={{ textAlign: 'center', marginBottom: '40px' }}>
                        <h2 style={{ 
                          fontSize: '24px', 
                          fontWeight: '600', 
                          marginBottom: '20px',
                          color: '#333'
                        }}>
                          Invitation Conflict
                        </h2>
                        <p style={{ 
                          fontSize: '16px', 
                          lineHeight: '1.6', 
                          marginBottom: '12px',
                          color: '#666'
                        }}>
                          You are currently logged in as <strong style={{ color: '#0B2A1B' }}>{currentUser?.email}</strong>, 
                          but this invitation is for <strong style={{ color: '#0B2A1B' }}>{invitedEmail}</strong>.
                        </p>
                        <p style={{ 
                          fontSize: '14px', 
                          lineHeight: '1.6', 
                          color: '#666'
                        }}>
                          Please log out and log in as the invited account, or create a new account.
                        </p>
                      </div>

                      <div style={{ marginBottom: '20px' }}>
                        <Button
                          type="primary"
                          size="large"
                          className="btn-success"
                          onClick={handleLogoutAndContinue}
                          block
                          style={{ marginBottom: '16px', height: '48px' }}
                        >
                          Logout and continue signup
                        </Button>
                        
                        <Button
                          size="large"
                          type="default"
                          onClick={handleSkipInvite}
                          block
                          className="skip-invite-btn"
                          style={{ 
                            height: '48px',
                            border: '1px solid #d9d9d9',
                            backgroundColor: 'transparent',
                            color: '#666',
                            transition: 'all 0.3s ease'
                          }}
                        >
                          Skip this invite
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </SignUpStyleWrapper>
        </AgencyStyleWrapper>
      </Col>
    </Row>
    </>
  );
};

export default InvitationConflict;